import {
  DescriptionWrapper,
  Separator,
  DescriptionParagraph,
  DescriptionTitle
} from './Description.styles';

type OwnProps = {
  shouldDisplayAssetOwnerLayout: boolean;
};

export default function Description({
  shouldDisplayAssetOwnerLayout
}: OwnProps) {
  return (
    <DescriptionWrapper
      shouldDisplayAssetOwnerLayout={shouldDisplayAssetOwnerLayout}
    >
      <Separator />
      <DescriptionTitle>
        {shouldDisplayAssetOwnerLayout
          ? 'Sharing is Caring'
          : 'Like my ride? Get your own'}
      </DescriptionTitle>
      <DescriptionParagraph>
        {shouldDisplayAssetOwnerLayout
          ? 'You earned this car. You should show it off!'
          : 'Experience the new way to buy a car with Carvana!'}
      </DescriptionParagraph>
    </DescriptionWrapper>
  );
}
